import { render, staticRenderFns } from "./ArrowUp.vue?vue&type=template&id=5b1db5d3&"
import script from "./ArrowUp.vue?vue&type=script&setup=true&lang=js&"
export * from "./ArrowUp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports